import type {
  WorkspaceAccessResourceType,
  WorkspaceMembershipFilter,
  WorkspacePeopleSearchPage,
} from "@playbookai/types";
import type { ApiClientConfig } from "./client-config.js";
import { apiCall } from "./http.js";

/**
 * The canonical resource-scoped people search, for SOLVE, VSM and Hoshin.
 *
 * Lives in `@playbookai/api-clients` rather than in a feature package because
 * all three consume it, and a feature package may never import a sibling
 * feature package (ADR-0009). Each module still keeps its own small adapter for
 * endpoints, query keys and presentation — this is only the transport.
 */
export function searchWorkspacePeople(
  config: ApiClientConfig,
  resourceType: WorkspaceAccessResourceType,
  resourceId: string,
  input: {
    readonly query: string;
    readonly cursor?: string | null;
    readonly membershipFilter?: WorkspaceMembershipFilter;
  },
  signal?: AbortSignal,
): Promise<WorkspacePeopleSearchPage> {
  return apiCall<WorkspacePeopleSearchPage>(
    config,
    "POST",
    `/v1/workspace-access/${encodeURIComponent(resourceType)}/${encodeURIComponent(resourceId)}/people/search`,
    {
      query: input.query,
      ...(input.cursor ? { cursor: input.cursor } : {}),
      ...(input.membershipFilter
        ? { membershipFilter: input.membershipFilter }
        : {}),
    },
    undefined,
    signal,
  );
}
